// src/components/LocationSearchBox.js
import React from "react";
import { Autocomplete, TextField, Box } from "@mui/material";
import { ReactComponent as IconAutoComplete } from "../assets/icons/icon-location-default.svg";
import { TOP_AUTOCOMPLETE_ICON_POSITION } from "../constants/constants";

export default function LocationSearchBox({
  searchQuery,      // controlled text value
  suggestions,      // array of { description, place_id, ... }
  onInputChange,    // (e: React.SyntheticEvent, v: string) => void
  onSelect,         // (prediction) => void
  textFieldProps = {},
  sx = {},
}) {
  return (
    <>
      <Box
        sx={{
          position: "fixed",
          top: `${TOP_AUTOCOMPLETE_ICON_POSITION}px`,
          width: 50,
          height: 50,
          left: 16,
          display: "flex",
          alignItems: "center",
          zIndex: 2,
          pointerEvents: "none",
        }}
      >
        <IconAutoComplete style={{ width: 50, height: 50 }} />
      </Box>
      <Autocomplete
        freeSolo
        options={suggestions.map((s) => s.description)}
        value={searchQuery}
        onInputChange={onInputChange}
        onChange={(e, selected) => {
          const match = suggestions.find((s) => s.description === selected);
          if (match) onSelect(match);
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            placeholder="Search or type an address"
            variant="outlined"
            size="small"
            {...textFieldProps}
          />
        )}
        sx={sx}
      />
    </>
  );
}
